/** SATHI Export: packed lots in the SATHI portal columns, as Excel. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { SathiPage } from "@/features/packaging/components/sathi-page";

const search = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
});

export const Route = createFileRoute("/_app/packaging/sathi/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <SathiPage
      facilityId={selected?.id}
      from={s.from ?? ""}
      to={s.to ?? ""}
      onRange={(next) =>
        void navigate({
          search: (prev) => ({
            ...prev,
            from: next.from || undefined,
            to: next.to || undefined,
          }),
        })
      }
    />
  );
}
